module.exports = "/assets/data/ca483172ce5f2118ae58698f6a52ee3b-HP3.data.json";